module.exports = __webpack_public_path__ + "media/images/esc_convenio_FUERTE-4aa62e3f150030da28ddef6dd97b4008.svg";